/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ChargingSuccessRateResponse,
    ChargingSuccessRateTrendResponse,
    DeviceSessionSummary,
    GroupedChargingSuccessRateTrendResponse,
    OrgSessionSummary,
    SiteSessionSummary,
} from "../models/index";
import {
    ChargingSuccessRateResponseFromJSON,
    ChargingSuccessRateResponseToJSON,
    ChargingSuccessRateTrendResponseFromJSON,
    ChargingSuccessRateTrendResponseToJSON,
    DeviceSessionSummaryFromJSON,
    DeviceSessionSummaryToJSON,
    GroupedChargingSuccessRateTrendResponseFromJSON,
    GroupedChargingSuccessRateTrendResponseToJSON,
    OrgSessionSummaryFromJSON,
    OrgSessionSummaryToJSON,
    SiteSessionSummaryFromJSON,
    SiteSessionSummaryToJSON,
} from "../models/index";

export interface GetConnectorChargingSuccessRateRequest {
    deviceIdentity: string;
    connectorIndex: number;
    from?: string;
    to?: string;
}

export interface GetConnectorChargingSuccessRateTrendRequest {
    deviceIdentity: string;
    connectorIndex: number;
    from?: string;
    to?: string;
}

export interface GetDeviceChargingSuccessRateRequest {
    deviceIdentity: string;
    from?: string;
    to?: string;
}

export interface GetDeviceChargingSuccessRateTrendRequest {
    deviceIdentity: string;
    from?: string;
    to?: string;
}

export interface GetDeviceGroupChargingSuccessRateRequest {
    deviceGroupTag: string;
    from?: string;
    to?: string;
}

export interface GetDeviceGroupChargingSuccessRateTrendRequest {
    deviceGroupTag: string;
    from?: string;
    to?: string;
}

export interface GetGlobalChargingSuccessRateRequest {
    from?: string;
    to?: string;
}

export interface GetGlobalChargingSuccessRateTrendRequest {
    from?: string;
    to?: string;
}

export interface GetGroupedChargingSuccessRateTrendByDeviceRequest {
    deviceIdentities: Array<string>;
    from?: string;
    to?: string;
}

export interface GetGroupedChargingSuccessRateTrendByDeviceGroupRequest {
    deviceGroupTags: Array<string>;
    from?: string;
    to?: string;
}

export interface GetGroupedSessionsByDeviceRequest {
    from?: string;
    to?: string;
    deviceGroupTag?: string;
}

export interface GetGroupedSessionsByOrgRequest {
    from?: string;
    to?: string;
}

export interface GetGroupedSessionsBySiteRequest {
    from?: string;
    to?: string;
    organisationId?: string;
}

/**
 *
 */
export class ChargingSuccessRateHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get charging success rate for a specific connector for a specified date range.
     */
    async getConnectorChargingSuccessRateRaw(
        requestParameters: GetConnectorChargingSuccessRateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getConnectorChargingSuccessRate().',
            );
        }

        if (requestParameters["connectorIndex"] == null) {
            throw new runtime.RequiredError(
                "connectorIndex",
                'Required parameter "connectorIndex" was null or undefined when calling getConnectorChargingSuccessRate().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/connector/{deviceIdentity}/{connectorIndex}`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"connectorIndex"}}`,
                        encodeURIComponent(
                            String(requestParameters["connectorIndex"]),
                        ),
                    ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get charging success rate for a specific connector for a specified date range.
     */
    async getConnectorChargingSuccessRate(
        requestParameters: GetConnectorChargingSuccessRateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateResponse> {
        const response = await this.getConnectorChargingSuccessRateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily charging success rate trend for a specific connector for a specified date range.
     */
    async getConnectorChargingSuccessRateTrendRaw(
        requestParameters: GetConnectorChargingSuccessRateTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateTrendResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getConnectorChargingSuccessRateTrend().',
            );
        }

        if (requestParameters["connectorIndex"] == null) {
            throw new runtime.RequiredError(
                "connectorIndex",
                'Required parameter "connectorIndex" was null or undefined when calling getConnectorChargingSuccessRateTrend().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/trend/connector/{deviceIdentity}/{connectorIndex}`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"connectorIndex"}}`,
                        encodeURIComponent(
                            String(requestParameters["connectorIndex"]),
                        ),
                    ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateTrendResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get daily charging success rate trend for a specific connector for a specified date range.
     */
    async getConnectorChargingSuccessRateTrend(
        requestParameters: GetConnectorChargingSuccessRateTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateTrendResponse> {
        const response = await this.getConnectorChargingSuccessRateTrendRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get charging success rate for a specific device for a specified date range.
     */
    async getDeviceChargingSuccessRateRaw(
        requestParameters: GetDeviceChargingSuccessRateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getDeviceChargingSuccessRate().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/device/{deviceIdentity}`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get charging success rate for a specific device for a specified date range.
     */
    async getDeviceChargingSuccessRate(
        requestParameters: GetDeviceChargingSuccessRateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateResponse> {
        const response = await this.getDeviceChargingSuccessRateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily charging success rate trend for a specific device for a specified date range.
     */
    async getDeviceChargingSuccessRateTrendRaw(
        requestParameters: GetDeviceChargingSuccessRateTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateTrendResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getDeviceChargingSuccessRateTrend().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/trend/device/{deviceIdentity}`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateTrendResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get daily charging success rate trend for a specific device for a specified date range.
     */
    async getDeviceChargingSuccessRateTrend(
        requestParameters: GetDeviceChargingSuccessRateTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateTrendResponse> {
        const response = await this.getDeviceChargingSuccessRateTrendRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get charging success rate for a specific device group (org, site, or service model) for a specified date range.
     */
    async getDeviceGroupChargingSuccessRateRaw(
        requestParameters: GetDeviceGroupChargingSuccessRateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateResponse>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling getDeviceGroupChargingSuccessRate().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/device-group/{deviceGroupTag}`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get charging success rate for a specific device group (org, site, or service model) for a specified date range.
     */
    async getDeviceGroupChargingSuccessRate(
        requestParameters: GetDeviceGroupChargingSuccessRateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateResponse> {
        const response = await this.getDeviceGroupChargingSuccessRateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily charging success rate trend for a specific device group (org, site, or service model) for a specified date range.
     */
    async getDeviceGroupChargingSuccessRateTrendRaw(
        requestParameters: GetDeviceGroupChargingSuccessRateTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateTrendResponse>> {
        if (requestParameters["deviceGroupTag"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTag",
                'Required parameter "deviceGroupTag" was null or undefined when calling getDeviceGroupChargingSuccessRateTrend().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/trend/device-group/{deviceGroupTag}`.replace(
                    `{${"deviceGroupTag"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceGroupTag"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateTrendResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get daily charging success rate trend for a specific device group (org, site, or service model) for a specified date range.
     */
    async getDeviceGroupChargingSuccessRateTrend(
        requestParameters: GetDeviceGroupChargingSuccessRateTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateTrendResponse> {
        const response = await this.getDeviceGroupChargingSuccessRateTrendRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get global charging success rate for a specified date range. Returns average CSR, session counts, and percentage change from previous period.
     */
    async getGlobalChargingSuccessRateRaw(
        requestParameters: GetGlobalChargingSuccessRateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateResponse>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/global`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get global charging success rate for a specified date range. Returns average CSR, session counts, and percentage change from previous period.
     */
    async getGlobalChargingSuccessRate(
        requestParameters: GetGlobalChargingSuccessRateRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateResponse> {
        const response = await this.getGlobalChargingSuccessRateRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get global daily charging success rate trend for a specified date range. Returns array of daily data points.
     */
    async getGlobalChargingSuccessRateTrendRaw(
        requestParameters: GetGlobalChargingSuccessRateTrendRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ChargingSuccessRateTrendResponse>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/trend/global`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ChargingSuccessRateTrendResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get global daily charging success rate trend for a specified date range. Returns array of daily data points.
     */
    async getGlobalChargingSuccessRateTrend(
        requestParameters: GetGlobalChargingSuccessRateTrendRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ChargingSuccessRateTrendResponse> {
        const response = await this.getGlobalChargingSuccessRateTrendRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get daily charging success rate trends for specific devices. Requires a list of device identities (max 10).
     */
    async getGroupedChargingSuccessRateTrendByDeviceRaw(
        requestParameters: GetGroupedChargingSuccessRateTrendByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<GroupedChargingSuccessRateTrendResponse>> {
        if (requestParameters["deviceIdentities"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentities",
                'Required parameter "deviceIdentities" was null or undefined when calling getGroupedChargingSuccessRateTrendByDevice().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceIdentities"] != null) {
            queryParameters["deviceIdentities"] = requestParameters[
                "deviceIdentities"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/trend/grouped/by-device`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            GroupedChargingSuccessRateTrendResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get daily charging success rate trends for specific devices. Requires a list of device identities (max 10).
     */
    async getGroupedChargingSuccessRateTrendByDevice(
        requestParameters: GetGroupedChargingSuccessRateTrendByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<GroupedChargingSuccessRateTrendResponse> {
        const response =
            await this.getGroupedChargingSuccessRateTrendByDeviceRaw(
                requestParameters,
                initOverrides,
            );
        return await response.value();
    }

    /**
     * Get daily charging success rate trends for specific device groups. Requires a list of device group tags (max 10).
     */
    async getGroupedChargingSuccessRateTrendByDeviceGroupRaw(
        requestParameters: GetGroupedChargingSuccessRateTrendByDeviceGroupRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<GroupedChargingSuccessRateTrendResponse>> {
        if (requestParameters["deviceGroupTags"] == null) {
            throw new runtime.RequiredError(
                "deviceGroupTags",
                'Required parameter "deviceGroupTags" was null or undefined when calling getGroupedChargingSuccessRateTrendByDeviceGroup().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/trend/grouped/by-device-group`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            GroupedChargingSuccessRateTrendResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get daily charging success rate trends for specific device groups. Requires a list of device group tags (max 10).
     */
    async getGroupedChargingSuccessRateTrendByDeviceGroup(
        requestParameters: GetGroupedChargingSuccessRateTrendByDeviceGroupRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<GroupedChargingSuccessRateTrendResponse> {
        const response =
            await this.getGroupedChargingSuccessRateTrendByDeviceGroupRaw(
                requestParameters,
                initOverrides,
            );
        return await response.value();
    }

    /**
     * Get session summaries grouped by device. Returns session count, energy, CSR, and parent site/org info for each device. Supports OData filtering on device properties.
     */
    async getGroupedSessionsByDeviceRaw(
        requestParameters: GetGroupedSessionsByDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceSessionSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["deviceGroupTag"] != null) {
            queryParameters["deviceGroupTag"] =
                requestParameters["deviceGroupTag"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/sessions/grouped/by-device`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceSessionSummaryFromJSON),
        );
    }

    /**
     * Get session summaries grouped by device. Returns session count, energy, CSR, and parent site/org info for each device. Supports OData filtering on device properties.
     */
    async getGroupedSessionsByDevice(
        requestParameters: GetGroupedSessionsByDeviceRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceSessionSummary>> {
        const response = await this.getGroupedSessionsByDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get session summaries grouped by organisation. Returns charger count, session count, energy, and CSR for each org. Supports OData filtering on organisation properties.
     */
    async getGroupedSessionsByOrgRaw(
        requestParameters: GetGroupedSessionsByOrgRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OrgSessionSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/sessions/grouped/by-org`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OrgSessionSummaryFromJSON),
        );
    }

    /**
     * Get session summaries grouped by organisation. Returns charger count, session count, energy, and CSR for each org. Supports OData filtering on organisation properties.
     */
    async getGroupedSessionsByOrg(
        requestParameters: GetGroupedSessionsByOrgRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OrgSessionSummary>> {
        const response = await this.getGroupedSessionsByOrgRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get session summaries grouped by site. Returns charger count, session count, energy, CSR, and parent org info for each site. Supports OData filtering on site properties.
     */
    async getGroupedSessionsBySiteRaw(
        requestParameters: GetGroupedSessionsBySiteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<SiteSessionSummary>>> {
        const queryParameters: any = {};

        if (requestParameters["from"] != null) {
            queryParameters["from"] = requestParameters["from"];
        }

        if (requestParameters["to"] != null) {
            queryParameters["to"] = requestParameters["to"];
        }

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/charging-success-rate/sessions/grouped/by-site`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(SiteSessionSummaryFromJSON),
        );
    }

    /**
     * Get session summaries grouped by site. Returns charger count, session count, energy, CSR, and parent org info for each site. Supports OData filtering on site properties.
     */
    async getGroupedSessionsBySite(
        requestParameters: GetGroupedSessionsBySiteRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<SiteSessionSummary>> {
        const response = await this.getGroupedSessionsBySiteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
